export const getRequestDate = (date) => {
  const [year, month, day] = date.split("-").map(Number);
  const dt = new Date(year, month - 1, day);
  return dt.toDateString();
};

export const formatDate = (date) => {
  date = new Date(date);
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
};
